module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CH-T"
  }, [_c('strong', [_vm._v("Creative Photography Ideas Using"), _c('br'), _vm._v("Adobe Photoshop")])]), _vm._v(" "), _c('h2', {
    staticClass: "CH-SUB"
  }, [_c('strong', [_vm._v("COMPOSITES AND FURTHER SPECIAL EFFECTS")])]), _vm._v(" "), _c('h3', {
    staticClass: "CH-AU"
  }, [_c('strong', [_vm._v("TONY WOROBIEC")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.gif"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1daa1e9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 57
// module chunks = 0